require('pdfjs-dist')
require('pdfjs-dist/build/pdf.worker')

export default class PdfViewer {
  constructor(element, file, page) {
    this.element = element
    this.file = file
    this.page = page

    this.parsePdf()
  }

  handlePage(page) {
    const viewport = page.getViewport({ scale: 1.3333 })

    const canvas = document.createElement('canvas')
    canvas.style.display = 'block'
    canvas.classList.add('pdf-viewer__page')

    const context = canvas.getContext('2d')

    canvas.height = viewport.height
    canvas.width = viewport.width

    page.render({ canvasContext: context, viewport: viewport })
    this.element.appendChild(canvas)
  }

  parsePdf() {
    pdfjsLib.getDocument(this.file).promise.then((pdfFile) => {
      pdfFile.getPage(this.page).then((page) => {
        this.handlePage(page)
      })
    })
  }
}
